<template>
  <div class="login-page">
    <!-- Panel kiri: identitas & branding (blueprint style, senada dengan dashboard) -->
    <aside class="login-aside">
      <div class="login-aside__grid" aria-hidden="true"></div>
      <div class="login-aside__glow" aria-hidden="true"></div>

      <div class="login-aside__content">
        <div class="login-aside__brand">
          <img
            class="login-aside__logo"
            :src="require('@/assets/logo/favicon.png')"
            alt="Logo" />
          <div>
            <div class="login-aside__brand-title">SIMPELBANG</div>
            <div class="login-aside__brand-sub">Bagian Administrasi Pembangunan Kabupaten Klaten</div>
          </div>
        </div>

        <h1 class="login-aside__headline">
          Sistem Pelaporan Pembangunan<br />
          Kabupaten Klaten
        </h1>
        <p class="login-aside__desc">
          Pusat data dan alat bantu pelaporan perkembangan fisik serta
          penyerapan keuangan program pembangunan daerah.
        </p>

        <ul class="login-aside__fn-list">
          <li>
            <span class="login-aside__fn-icon">
              <v-icon size="15" color="#E69F00">mdi-file-chart-outline</v-icon>
            </span>
            <span>
              <strong>Pelaporan Fisik &amp; Keuangan</strong>
              <em>Progres pekerjaan &amp; realisasi anggaran berkala</em>
            </span>
          </li>
          <li>
            <span class="login-aside__fn-icon">
              <v-icon size="15" color="#E69F00">mdi-clipboard-check-outline</v-icon>
            </span>
            <span>
              <strong>Pengendalian Program</strong>
              <em>Pemantauan &amp; evaluasi kegiatan pembangunan</em>
            </span>
          </li>
          <li>
            <span class="login-aside__fn-icon">
              <v-icon size="15" color="#E69F00">mdi-briefcase-check-outline</v-icon>
            </span>
            <span>
              <strong>Tertib Administrasi Anggaran</strong>
              <em>Pembaruan laporan kinerja tiap Perangkat Daerah</em>
            </span>
          </li>
        </ul>
      </div>

      <div class="login-aside__footer">
        © {{ new Date().getFullYear() }} Bagian Administrasi Pembangunan,
        Sekretariat Daerah Kabupaten Klaten
      </div>
    </aside>

    <!-- Panel kanan: form login -->
    <main class="login-main">
      <div class="login-main__grid" aria-hidden="true"></div>

      <div class="login-card">
        <span class="login-card__corner login-card__corner--tl"></span>
        <span class="login-card__corner login-card__corner--br"></span>

        <div class="login-card__mobile-brand">
          <img
            class="login-card__mobile-logo"
            :src="require('@/assets/logo.png')"
            alt="Logo" />
          <div class="login-card__mobile-title">SIMPELBANG</div>
        </div>

        <div class="login-card__head">
          <div class="login-card__eyebrow">Selamat datang kembali</div>
          <h2 class="login-card__title">Masuk Admin</h2>
          <p class="login-card__subtitle">Masukkan kredensial Anda untuk melanjutkan</p>
        </div>

        <ValidationObserver ref="observer">
          <v-form class="login-form">
            <ValidationProvider
              name="username"
              rules="required"
              v-slot="{ errors }">
              <label class="login-field__label">Username</label>
              <v-text-field
                v-on:keyup.enter="recaptcha()"
                class="no_box login-field"
                solo
                flat
                dense
                outlined
                :color="set_color"
                placeholder="Masukkan username"
                prepend-inner-icon="mdi-account-outline"

                vv-uppercase

                v-model="form.username"
                :error-messages="errors"
                required>
              </v-text-field>
            </ValidationProvider>

            <ValidationProvider
              name="password"
              rules="required|min:5|max:20"
              v-slot="{ errors }">
              <label class="login-field__label">Password</label>
              <v-text-field
                v-on:keyup.enter="save()"
                class="no_box login-field"
                solo
                flat
                dense
                outlined
                :color="set_color"
                placeholder="Masukkan password"
                :type="show ? 'text' : 'password'"
                prepend-inner-icon="mdi-lock-outline"
                :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="show = !show"
                :counter="50"

                vv-uppercase

                v-model="form.password"
                :error-messages="errors"
                required>
              </v-text-field>
            </ValidationProvider>
          </v-form>
        </ValidationObserver>

        <div v-if="message.error.length > 0" class="login-error">
          <v-icon size="17" color="#D55E00">mdi-alert-circle-outline</v-icon>
          <span>{{ message.error }}</span>
        </div>

        <v-btn
          v-on:keyup.enter="save"
          :disabled="process.form"
          :loading="process.form"
          @click="recaptcha()"
          block
          x-large
          elevation="0"
          class="login-submit text-capitalize">
          Masuk
        </v-btn>

        <!-- <div
          class="body-2 text-center black--text">
          Lupa password ?
        </div> -->
      </div>
    </main>
  </div>
</template>

<script>
  import { TokenService } from "@/service/Storage.Service";
  import axios from "axios";
  import { get, post, put, patch, destroy } from "@/service/Axios";
  export default {
    data() {
      return {
        show: false,
        form: {
          username: '',
          password: '',
          device: 'web'
        },
        process: {
          form: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    computed: {
      rps() {
        return this.$vuetify.breakpoint.name
      },
      company () {
        return this.$store.state.company
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r+35}, ${g+37}, ${b}, 0.97)`
      }
    },
    mounted () {
      this.fetch()

      let counter = {
        total_company_quota: 0,
        total_company_quota_used: 0,
        total_company_quota_sisa: 0
      }

      TokenService.saveCounter(JSON.stringify(counter))

      this.$store.commit("setCounter", counter)
    },
    methods: {
      async fetch () {
        await get('config')
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            res.results.data[0].color = JSON.parse(res.results.data[0].color)

            TokenService.saveCompany(JSON.stringify(res.results.data[0]))

            this.$store.commit("setCompany", res.results.data[0])
            
            if (res.results.data[0].color.length > 0) {
              res.results.data[0].color.map((obj) => {
                if (obj.active) {
                  TokenService.saveColor(obj.hex)

                  this.$store.commit("setColor", obj.hex)
                }
              })
            } else {
              TokenService.saveColor('#DD5826')

              this.$store.commit("setColor", '#DD5826')
            }
          }
        })
      },

      async recaptcha() {
        this.message.error = ''
        // (optional) Wait until recaptcha has been loaded.
        const isValid = await this.$refs.observer.validate()
        if (isValid) {
          this.process.form = true
          await this.$recaptchaLoaded()

          // Execute reCAPTCHA with action "login".
          const token = await this.$recaptcha('login')

          // let formData = new FormData()
          //       formData.append('secret', '6LdXR4oqAAAAAL5KjnCLuncKPczuNlUCSsGgN7Gl')
          //       formData.append('response', '03AFcWeA5W_bPdL1iPsBMELSrK24b91zCMYrK30Pko2P2rbwDy0cfubF9qVXxKRBm-bgxBMmdvHjmPVlvOjZcorbWk_1CsVkSCL_r47WwINJOvXo-nH0ndzCLKgA1UG2W0b_XR8mSkbnF-gu5Cmg_Ahfofcq2YCbuaGvZJZSTO57MJktMsZo5g3-ZkRyqO7O-WozMhLzZ9xiqPI-Av7uOTmjyTHrXlmCxL2d8tXZHpKzcu3pnLx7tfU6858tRaDcmfThwGnf-ll5Qs4ha0OsWb5Vq6Lgwu63RgqWi4FYNVNktM2jD9Z4IzpDokFNCN16qH2bGxofr9g1-wx7uG4OWLwN_Lniy84if5Tm1YhRUCRCQWE7cRNCurKg_QpmxsHo2hj0weokq70eLVeOnzqgqqKc3eMMiDW7txv3c_Fa1KX4Um2zGDoXrDwJey5j1Aho_5h0ApxaVql3bRJ8IVRPpPBhOxb8VWQD90cYanbu6YpIyEbT6QzSGAK3JRC8axsyLbuDF9OFwgGnJagVKolwKIQUPRW6IBJjzhDhwr4rX_UvPX4ext4jp8PtyyfCwaQEjGzZcdHxOkDhupQcnsY7uuGkGrVmObo_GeMS2RCz2pFsbUDss9qrrENl1cDe87WaKkKSQ2xPbRJIV5ertFY0CJnwzD6sM9xrZmX7PlWwyIZDuVwqTOHNeTHpDAnKsI_tNxPUAgxo93BZDsaloQPcYQbc_mr2NxKi4a-y7ZmxmaXMUVR-VDrQX_NvTC7cgHqxcpGvMmz6eSD8YH3lLPn4jMMZA3SnIRvH1Uwx_Ix2BPRKFNQESZVsVyuslKOlRmlnskx7zCAqi_rhbvqkum2ZefCXOwIGT9Lv9vWtq6fDr9e_X-UxbUVV3QEGJK11sEfdF1xr6oSX_HDofNSfNWYd9DhbULocYV0k3L8PE5zUueQfvlwZe6pLn8rEoDNnXtbsiwfgEZfLM9IhtOBDyVeFjHjNgxclHg6VV8SDxYuuYh5yoT6xNWzg_KDZhxxXQrj8BD_a66EimgJKe84k_dCufwdAyDDwg9H7HPIx2OGnk3AhpeWSnT8bHH0Gu_Pk1A5csxHoxAvOcH8_J7k80nePFMoPu82vY74Emtd7WdcTkJSfGhwGDCCDLHBL2UpyoJtakrJE36OtCgnCOxNek8qTZnuyIIHJuR4taqr2KdAmCnAefngo7CSTzQIKR3-b-vNzTpe4_KXxBl7MlSxM2kh4W7_BeBdYrYRz7Zc_4CvP_Q050ebnOuBw6GTPOOKf0g3sSdqUptoAYE4JmYJfaPmCru57WpDJkAM3vT4-C9jXTOqAm5q_-vW5ABpIPvMMFlp5mROShue-XUyQxrVy6ZV_vftT8O3A3lroia5q8Z6moj46zV5BLBMsqZhOVghuUV_JOJnGt-z-FDK7xF8-Rxa2LnYCyLCAMhCT6Y3jkDmvAGxw0yn7sC6cHH9o9ePRcxF3P3XB0stz_e3m10CnL-oxO-dhVwzqhlFvJt4LX67Aepzh_rul084oW0iBFSVHOjj6OqWGiAgsaFMGTda0M7iGkTX2eEE1uahNsuO3jWBIQyoB8a-bT6mi5dt8h8U9WNeuiCNsoxNNPCKtaSk8sqJallrtYLyIvdssYO4iRXewyEaPo5V6O1J2yYEQQJ8wI3tO3Cead-wsKGbtWx7cclyL5vz9mspPmMNoPDmnPBvUhauhlOyBt7gwNdFJnpk3p8nsMsnxMqGf-2FUjJaWjdIPb7C7Ikf-ywL0FQX0_PyDM7KGawS-Y6gOz1P8Ssol3MgH6xQwlynufpcIiBdhl0iwJhTkS1ofLGb2dUHywYi1ae5WbSEhXBy6umVgGBCRZ12WdjmsPKy-CUIegjpxaqpyiIyS7Kv5x0h41MMHajXJ3wxffrQSfWWilNr8TFPZfI4AHi3bAnNz36_EP4')

          //   await fetch(`https://www.google.com/recaptcha/api/siteverify`, {
          //     method: 'POST',
          //     mode: 'no-cors',
          //     body: formData
          //   })
          //   .then(res => res.json())
          //   .then(response => {
          //     console.log(response)
          //   })

          let params = {
            // secret: '6Lf8XowqAAAAAHog6hbEywGNn53pqd5YEPLGAfHM',
            token: token,
            email: this.form.username,
          }

          await axios({
            url: `${process.env.VUE_APP_API_URL}admin/auth/validate`,
            method: 'POST',
            data: params,
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
              Authorization: process.env.VUE_APP_XAUTH
            }
          }).then((response) => {
            let res = response
            this.captcha = res.data.results.data.success

            if (this.captcha) {
              this.save(res.data.results.data.token)
            } else {
              this.process.form = false
              this.message.error = 'Kami menduga adanya aktivitas otomatis. Harap coba lagi untuk mengonfirmasi bahwa Anda adalah pengguna asli'
            }
            
          })
        }

        // Do stuff with the received token.
      },

      async save (token) {
        this.message.error = ''

        const isValid = await this.$refs.observer.validate()
        if (isValid) {
          this.process.form = true

          await post('admin/auth/login', {
            data: {
              username: this.form.username,
              password: this.form.password,
              device: this.form.device,
              token: token
            }
          })
          .then(response => {
            let res = response.data

            if (res.status === 200) {
              // console.log(res.results.data)
              let user = res.results.data,
                  menu = []

              if (user.role === 'admin') {
                menu = [
                  {
                    title: 'Dashboard',
                    icon: require('@/assets/icon/dashboard.png'),
                    link: '/dashboard',
                    active: true,
                    sub_menu: []
                  },
                  {
                    title: 'Anggaran Murni',
                    icon: require('@/assets/icon/program.png'),
                    link: '/program',
                    active: false,
                    sub_menu: []
                  },
                  {
                    title: 'Anggaran P1',
                    icon: require('@/assets/icon/program.png'),
                    link: '/program-p1',
                    active: false,
                    sub_menu: []
                  },
                  {
                    title: 'Anggaran Perubahan',
                    icon: require('@/assets/icon/update.png'),
                    link: '/program-perubahan',
                    active: false,
                    sub_menu: []
                  },
                  {
                    title: 'Laporan',
                    icon: require('@/assets/icon/laporan.png'),
                    link: '/laporan',
                    active: false,
                    sub_menu: [
                      {
                        title: 'Perkembangan Fisik & Keuangan',
                        link: '/laporan/perkembangan',
                        active: false
                      },
                      {
                        title: 'Capaian Kinerja',
                        link: '/laporan/capaian',
                        active: false
                      },
                      {
                        title: 'Kendala',
                        link: '/laporan/kendala',
                        active: false
                      },
                      {
                        title: 'Rekap OPD',
                        link: '/laporan/rekapitulasi',
                        active: false
                      },
                      {
                        title: 'Perkembangan Fisik & Keuangan Publik',
                        link: '/laporan/perkembangan-opd-public',
                        active: false
                      },
                      {
                        title: 'Rekap OPD Publik',
                        link: '/laporan/rekap-opd-public',
                        active: false
                      },
                      {
                        title: 'Data Summary Anggaran',
                        link: '/laporan/summary-anggaran',
                        active: false
                      }
                    ]
                  },
                  {
                    title: 'Perbandingan SP2D',
                    icon: require('@/assets/icon/comparison.png'),
                    link: '/perbandingan-sp2d',
                    active: true,
                    sub_menu: []
                  },
                  {
                    title: 'User',
                    icon: require('@/assets/icon/user.png'),
                    link: '/user',
                    active: true,
                    sub_menu: []
                  },
                  {
                    title: 'Konfigurasi',
                    icon: require('@/assets/icon/setting.png'),
                    link: '/master',
                    active: false,
                    sub_menu: [
                      {
                        title: 'Perangkat Daerah',
                        icon: require('@/assets/icon/company.png'),
                        link: '/master/perusahaan',
                        active: false,
                        sub_menu: []
                      },
                      {
                        title: 'Unit',
                        icon: require('@/assets/icon/unit.png'),
                        link: '/master/unit',
                        active: false,
                        sub_menu: []
                      },
                      {
                        title: 'Dokumen',
                        icon: require('@/assets/icon/upload_folder.png'),
                        link: '/master/document',
                        active: false,
                        sub_menu: []
                      },
                      {
                        title: 'Import Anggaran',
                        icon: require('@/assets/icon/import.png'),
                        link: '/master/import-anggaran',
                        active: false,
                        sub_menu: []
                      }
                    ]
                  }
                ]
              } else {
                menu = [
                  {
                    title: 'Dashboard',
                    icon: require('@/assets/icon/dashboard.png'),
                    link: '/dashboard',
                    active: true,
                    sub_menu: []
                  },
                  {
                    title: 'Anggaran Murni',
                    icon: require('@/assets/icon/program.png'),
                    link: '/program',
                    active: false,
                    sub_menu: []
                  },
                  {
                    title: 'Anggaran P1',
                    icon: require('@/assets/icon/program.png'),
                    link: '/program-p1',
                    active: false,
                    sub_menu: []
                  },
                  {
                    title: 'Anggaran Perubahan',
                    icon: require('@/assets/icon/update.png'),
                    link: '/program-perubahan',
                    active: false,
                    sub_menu: []
                  },
                  {
                    title: 'Laporan',
                    icon: require('@/assets/icon/laporan.png'),
                    link: '/laporan',
                    active: false,
                    sub_menu: [
                      {
                        title: 'Perkembangan Fisik & Keuangan',
                        link: '/laporan/perkembangan',
                        active: false
                      },
                      {
                        title: 'Capaian Kinerja',
                        link: '/laporan/capaian',
                        active: false
                      },
                      {
                        title: 'Kendala',
                        link: '/laporan/kendala',
                        active: false
                      },
                    ]
                  },
                  {
                    title: 'Konfigurasi',
                    icon: require('@/assets/icon/setting.png'),
                    link: '/master',
                    active: false,
                    sub_menu: [
                      {
                        title: 'Informasi Unit',
                        icon: require('@/assets/icon/unit.png'),
                        link: '/master/informasi-unit',
                        active: false,
                        sub_menu: []
                      },
                      {
                        title: 'Dokumen',
                        icon: require('@/assets/icon/upload_folder.png'),
                        link: '/master/document',
                        active: false,
                        sub_menu: []
                      },
                    ]
                  }
                ]

                let menu_gabungan = [
                  {
                    title: 'Dashboard',
                    icon: require('@/assets/icon/dashboard.png'),
                    link: '/dashboard',
                    active: true,
                    sub_menu: []
                  },
                  {
                    title: 'Anggaran Murni',
                    icon: require('@/assets/icon/program.png'),
                    link: '/program',
                    active: false,
                    sub_menu: []
                  },
                  {
                    title: 'Anggaran P1',
                    icon: require('@/assets/icon/program.png'),
                    link: '/program-p1',
                    active: false,
                    sub_menu: []
                  },
                  {
                    title: 'Anggaran Perubahan',
                    icon: require('@/assets/icon/update.png'),
                    link: '/program-perubahan',
                    active: false,
                    sub_menu: []
                  },
                  {
                    title: 'Laporan',
                    icon: require('@/assets/icon/laporan.png'),
                    link: '/laporan',
                    active: false,
                    sub_menu: [
                      {
                        title: 'Perkembangan Fisik & Keuangan',
                        link: '/laporan/perkembangan',
                        active: false
                      },
                      {
                        title: 'Capaian Kinerja',
                        link: '/laporan/capaian',
                        active: false
                      },
                      {
                        title: 'Kendala',
                        link: '/laporan/kendala',
                        active: false
                      },
                      {
                        title: 'Rekap Gabungan',
                        link: '/laporan/rekapitulasi-gabungan',
                        active: false
                      }
                    ]
                  },
                  {
                    title: 'Konfigurasi',
                    icon: require('@/assets/icon/setting.png'),
                    link: '/master',
                    active: false,
                    sub_menu: [
                      {
                        title: 'Informasi Unit',
                        icon: require('@/assets/icon/unit.png'),
                        link: '/master/informasi-unit',
                        active: false,
                        sub_menu: []
                      },
                      {
                        title: 'Dokumen',
                        icon: require('@/assets/icon/upload_folder.png'),
                        link: '/master/document',
                        active: false,
                        sub_menu: []
                      },
                    ]
                  }
                ]

                menu = user.unit_id == '42' || user.unit_id == '43' || user.unit_id == '41' || user.unit_id == '32' || user.unit_id == '4' || user.unit_id == '6' || user.unit_id == '1' || user.unit_id == '492' || user.unit_id == '501' || user.unit_id == '496' || user.unit_id == '493' || user.unit_id == '537' || user.unit_id == '500' || user.unit_id == '494' || user.unit_id == '495' || user.unit_id == '538' || user.unit_id == '492' || user.unit_id == '326' || user.unit_id == '327' || user.unit_id == '328' || user.unit_id == '330' || user.unit_id == '329' || user.unit_id == '325' || user.unit_id == '334' || user.unit_id == '335' || user.unit_id == '313' || user.unit_id == '179' || user.unit_type == "Pendidikan" || user.unit_type == "Puskesmas" ? menu_gabungan : menu
              }

              
              TokenService.saveToken(
                res.results.token,
                JSON.stringify(user),
                JSON.stringify(menu)
              )

              TokenService.saveReload(false)

              TokenService.saveYear(new Date().getFullYear())

              window.location = `${process.env.BASE_URL}dashboard`
            } else {
              this.process.form = false
              this.message.error = res.message
            }
          })
        }
      }
    }
  }
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@500;600;700;800&family=Inter:wght@400;500;600;700&display=swap');

.login-page {
  --sb-navy: #0B2440;
  --sb-navy-2: #0F3157;
  --sb-blue: #0072B2;
  --sb-skyblue: #56B4E9;
  --sb-gold: #E69F00;
  --sb-green: #009E73;
  --sb-red: #D55E00;
  --sb-purple: #CC79A7;
  --sb-bg: #EEF2F7;
  --sb-surface: #FFFFFF;
  --sb-border: #E1E7EF;
  --sb-ink: #10233B;
  --sb-muted: #647389;

  height: 100vh;
  display: flex;
  background: var(--sb-bg);
  color: var(--sb-ink);
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
  -webkit-font-smoothing: antialiased;
  position: relative;
  overflow: hidden;
}

/* ===== Panel kiri: branding ===== */
.login-aside {
  position: relative;
  flex: 0 0 40%;
  max-width: 520px;
  min-width: 360px;
  height: 100vh;
  padding: clamp(22px, 3vw, 40px) clamp(26px, 3vw, 44px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 18px;
  background: linear-gradient(150deg, var(--sb-navy) 0%, var(--sb-navy-2) 60%, #123a68 100%);
  overflow: hidden;
}

.login-aside__grid {
  position: absolute;
  inset: 0;
  pointer-events: none;
  background-image:
    linear-gradient(rgba(255, 255, 255, 0.05) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255, 255, 255, 0.05) 1px, transparent 1px);
  background-size: 32px 32px;
  mask-image: radial-gradient(ellipse at top left, black 0%, transparent 78%);
}

.login-aside__glow {
  position: absolute;
  width: 380px;
  height: 380px;
  border-radius: 50%;
  right: -150px;
  bottom: -130px;
  background: radial-gradient(circle, rgba(230, 159, 0, 0.26) 0%, rgba(230, 159, 0, 0) 70%);
  pointer-events: none;
}

.login-aside__content {
  position: relative;
  z-index: 1;
  flex-shrink: 0;
}

.login-aside__brand {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: clamp(18px, 2.6vw, 28px);
}

.login-aside__logo {
  width: 40px;
  height: 40px;
  object-fit: contain;
  border-radius: 11px;
  background: rgba(255, 255, 255, 0.92);
  padding: 5px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);
  flex-shrink: 0;
}

.login-aside__brand-title {
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-weight: 800;
  font-size: 16px;
  color: #ffffff;
  letter-spacing: 0.01em;
}

.login-aside__brand-sub {
  font-size: 11.5px;
  color: rgba(255, 255, 255, 0.6);
  font-weight: 500;
  margin-top: 1px;
}

.login-aside__headline {
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-weight: 800;
  font-size: clamp(18px, 1.75vw, 25px);
  line-height: 1.28;
  color: #ffffff;
  letter-spacing: -0.01em;
  margin: 0 0 10px;
}

.login-aside__desc {
  font-size: 13px;
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.68);
  max-width: 400px;
  margin: 0 0 clamp(16px, 2.2vw, 22px);
}

.login-aside__fn-list {
  list-style: none;
  margin: 0 0 clamp(16px, 2.2vw, 22px);
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.login-aside__fn-list li {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.login-aside__fn-list li span:last-child {
  display: flex;
  flex-direction: column;
  gap: 1px;
  min-width: 0;
}

.login-aside__fn-list strong {
  font-size: 12px;
  font-weight: 700;
  color: #ffffff;
  line-height: 1.3;
}

.login-aside__fn-list em {
  font-style: normal;
  font-size: 11px;
  color: rgba(255, 255, 255, 0.5);
  line-height: 1.35;
}

.login-aside__fn-icon {
  width: 26px;
  height: 26px;
  border-radius: 8px;
  flex-shrink: 0;
  margin-top: 1px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(230, 159, 0, 0.14);
  border: 1px solid rgba(230, 159, 0, 0.28);
}

.login-aside__footer {
  position: relative;
  z-index: 1;
  flex-shrink: 0;
  font-size: 10.5px;
  color: rgba(255, 255, 255, 0.4);
  font-weight: 500;
  line-height: 1.5;
  margin-top: 18px;
}

/* ===== Panel kanan: form ===== */
.login-main {
  position: relative;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: clamp(20px, 3vw, 40px);
  height: 100vh;
  overflow-y: auto;
}

.login-main__grid {
  position: absolute;
  inset: 0;
  pointer-events: none;
  background-image:
    linear-gradient(rgba(11, 36, 64, 0.028) 1px, transparent 1px),
    linear-gradient(90deg, rgba(11, 36, 64, 0.028) 1px, transparent 1px);
  background-size: 32px 32px;
  mask-image: radial-gradient(ellipse at bottom right, black 0%, transparent 70%);
}

.login-card {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 396px;
  background: var(--sb-surface);
  border: 1px solid var(--sb-border);
  border-radius: 16px;
  box-shadow: 0 18px 44px rgba(11, 36, 64, 0.1);
  padding: clamp(24px, 3.4vw, 34px);
}

.login-card__corner {
  position: absolute;
  width: 16px;
  height: 16px;
  pointer-events: none;
  opacity: 0.6;
}

.login-card__corner--tl {
  top: 10px;
  left: 10px;
  border-top: 2px solid var(--sb-gold);
  border-left: 2px solid var(--sb-gold);
  border-radius: 3px 0 0 0;
}

.login-card__corner--br {
  bottom: 10px;
  right: 10px;
  border-bottom: 2px solid var(--sb-blue);
  border-right: 2px solid var(--sb-blue);
  border-radius: 0 0 3px 0;
}

.login-card__mobile-brand {
  display: none;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 1px solid var(--sb-border);
}

.login-card__mobile-logo {
  width: 32px;
  height: 32px;
  object-fit: contain;
}

.login-card__mobile-title {
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-weight: 800;
  font-size: 14px;
  color: var(--sb-navy);
}

.login-card__head {
  margin-bottom: 12px;
}

.login-card__eyebrow {
  font-size: 10.5px;
  font-weight: 700;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  color: var(--sb-gold);
  margin-bottom: 5px;
}

.login-card__title {
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-weight: 800;
  font-size: 22px;
  color: var(--sb-navy);
  margin: 0 0 5px;
  letter-spacing: -0.01em;
}

.login-card__subtitle {
  font-size: 12.5px;
  color: var(--sb-muted);
  margin: 0;
}

.login-form {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.login-field__label {
  display: block;
  font-size: 11.5px;
  font-weight: 700;
  color: var(--sb-ink);
  margin: 12px 0 6px;
}

.login-field::v-deep .v-input__slot {
  border-radius: 10px !important;
  min-height: 40px !important;
  padding: 0 12px !important;
  box-shadow: none !important;
  display: flex !important;
  align-items: center !important;
}

.login-field::v-deep fieldset {
  border-color: var(--sb-border) !important;
}

.login-field::v-deep input {
  font-size: 13.5px;
}

.login-field::v-deep .v-text-field__slot {
  display: flex;
  align-items: center;
}

.login-field::v-deep .v-input__prepend-inner,
.login-field::v-deep .v-input__append-inner {
  margin-top: 0 !important;
  align-self: center;
}

.login-field::v-deep .v-text-field__details {
  margin-bottom: 0 !important;
  padding-top: 2px;
}

.login-error {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-top: 8px;
  padding: 9px 11px;
  border-radius: 10px;
  background: rgba(213, 94, 0, 0.08);
  color: #954200;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.5;
}

.login-submit {
  margin-top: 18px !important;
  height: 47px !important;
  border-radius: 10px !important;
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-weight: 700 !important;
  font-size: 14.5px !important;
  color: #ffffff !important;
  letter-spacing: 0.01em;
  background: linear-gradient(180deg, #0072B2 0%, #0B2440 100%);
  box-shadow: 0 8px 20px rgba(11, 36, 64, 0.22);
}

/* ===== Responsif ===== */
@media (max-width: 960px) {
  .login-page {
    height: auto;
    min-height: 100vh;
    overflow: auto;
  }

  .login-aside {
    display: none;
  }

  .login-main {
    height: auto;
    min-height: 100vh;
  }

  .login-card__mobile-brand {
    display: flex;
  }

  .login-main {
    padding: 20px;
  }
}

@media (max-width: 480px) {
  .login-card {
    padding: 22px 18px;
    border-radius: 14px;
    box-shadow: none;
    border: none;
  }

  .login-main {
    padding: 0;
    align-items: flex-start;
    padding-top: 28px;
  }
}
</style>